// eslint-disable-next-line @nx/enforce-module-boundaries
import { InboxImageService } from '@galaxy/conversation/core';
import { ImageService } from '../core/image.service';

// External
// For adapting the ImageService to suit ImageService for Inbox
export function imageServiceFactory(imageService: ImageService): InboxImageService {
  return {
    getImageSrc: (imageName: string) => {
      return imageService.getImageSrc(imageName);
    },
  };
}
